type ShouldBlockFormNavigationProps = {
  isDirty: boolean
  isSubmitting: boolean
  allowSamePathNavigation?: boolean
  currentPathname: string
  nextPathname: string
}

export const shouldBlockFormNavigation = ({
  isDirty,
  isSubmitting,
  allowSamePathNavigation,
  currentPathname,
  nextPathname,
}: ShouldBlockFormNavigationProps): boolean =>
  isDirty && !isSubmitting && (!allowSamePathNavigation || currentPathname !== nextPathname)
